import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md, fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const subtitle = css`
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const actions = css`
  display: flex;
  flex-direction: row;
  gap: ${spacing(2)};
`

export const tableCard = css`
  display: flex;
  flex-direction: column;
`

export const toolbar = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const search = css`
  flex: 1;
`

export const table = css`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
    padding: ${spacing(4)} ${spacing(5)};
  }

  th {
    ${fontRegular};
    color: ${text_colorTextSecondary};
    font-weight: 500;
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  td {
    ${fontRegular};
    color: ${text_colorTextPrimary};
  }
`

export const actionCell = css`
  text-align: right;
`

export const footer = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing(2)};
  padding: ${spacing(3)} ${spacing(5)};
  color: ${text_colorTextSecondary};
  ${fontRegular};
`

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
